
(function documentTypeControllerDefinition() {
    'use strict';

    angular.module('DocumentType')
        .controller('DocumentTypeImportController', [
            '$scope', '$state', 'errorsExtend', 'adminDocumentTypeService', 'fileService', 'organizationalUnitService',
            function documentTypeImportController($scope, $state, errors, adminDocumentTypeService, fileService, organizationalUnitService) {

                $scope.title = 'Import Title';

                $scope.tempFiles = [];
                $scope.files = [];
                $scope.model = {
                    organizationalUnit: null
                };

                organizationalUnitService.getOuTReeControl().then(function (result) {
                    $scope.organizationalUnits = result;
                }, function (error) {
                    errors.showError(error);
                });

                $scope.addFile = function () {
                    $scope.tempFiles.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            var index = $scope.getIndexFile(file);
                            if (~index) {
                                $scope.files[index] = file;
                            } else {
                                $scope.files.push(file);
                            }
                        }
                    });

                    $scope.tempFiles = [];
                };

                $scope.removeFile = function (item) {
                    var index = $scope.getIndexFile(item);

                    if (~index) {
                        $scope.files.splice(index, 1);
                    }
                };

                $scope.getIndexFile = function (fileNew) {
                    for (var i in $scope.files) {
                        if ($scope.files.hasOwnProperty(i)) {
                            var fileOld = $scope.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    }

                    return -1;
                };

                $scope.import = function (version) {
                    if ($scope.files.length === 0) {
                        errors.showError("Debe seleccionar al menos un archivo.");
                        return;
                    }

                    for (var i = 0; i < $scope.files.length; i++) {
                        var ext = $scope.files[i].name.split(".").pop().toLowerCase();

                        if (ext !== 'edr' && version == 0) {
                            errors.showError("Los archivos deben tener la extension .edr");
                            return;
                        }

                        if (ext !== 'zip' && version == 1) {
                            errors.showError("Los archivos deben tener la extension .zip");
                            return;
                        }
                    }

                    var idOu = undefined;

                    if ($scope.model.organizationalUnit) {
                        idOu = $scope.model.organizationalUnit.id;
                    }

                    return adminDocumentTypeService.import($scope.files, version, idOu).then(function (docType) {
                        $state.go('document-type-find');
                    }, function (error) {
                        if (error.data && error.data.modelState) {
                            var keys = Object.keys(error.data.modelState);
                            if (keys.length > 1) {
                                var errorsMsj = '\n';

                                for (var i = 0; i < keys.length; i++) {
                                    errorsMsj += error.data.modelState[keys[i]] + '\n';
                                }

                                return errors.showError({
                                    status: error.status,
                                    data: {
                                        key: 'DocumentTypeImportError',
                                        value: {
                                            errorDetail: errorsMsj
                                        }
                                    }
                                });
                            }
                        }

                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go('document-type-find');
                };
            }
        ]);
})();